module.exports = __webpack_public_path__ + "static/media/estrados_500x325.5de543cd.png";